export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';

export const updateProfile = (accounts) => ({ type: UPDATE_USER_PROFILE, accounts });
